import { createFileRoute, redirect } from '@tanstack/react-router'

// The section was renamed from Insights to Data Sources. Sends old links and bookmarks, with their search and hash,
// to the same page under the new path.
export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise/insights/$')({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace(
        '/crt/pricing-excise/insights',
        '/crt/pricing-excise/data-sources',
      ),
      replace: true,
    })
  },
})
